import apiRequest from './apiRequest';

const useChatResolver = () => {
  const resolveChat = async ({ receiverId, postId, image }) => {
    try {
      // 1️⃣ Ищем существующий чат
      const res = await apiRequest.get('/chats/search', {
        params: { receiverId, postId }
      });
      return res.data;
    } catch (err) {
      // 2️⃣ Если нет — создаём
      if (err.response?.status === 404) {
        const createRes = await apiRequest.post('/chats', {
          receiverId,
          postId,
          image
        });
        return createRes.data;
      }
      // Другие ошибки
      throw err;
    }
  };

  return { resolveChat };
};

export default useChatResolver;
